import { NavigationSubItem } from "../navigation-item"

export class CreateLockSubItem extends NavigationSubItem {
  readonly id = "lock"
  readonly label = "Create"
  readonly href = "/lock/create"
  readonly iconName = "overview-icon"
  readonly isExternal = false
  readonly tabs = []
}
